module.exports = __webpack_public_path__ + "static/media/image-shutdown.93fede2d.png";